import { Controller, useForm } from "react-hook-form";
import { InputField } from "../../../CommonElements";
import { Fragment, useState, useEffect } from "react";
import ModalContainer from "../containers/ModalContainer";
import { Form } from "reactstrap";
import SignCanvasField from "../../../CommonElements/Form/SignCanvasFIeld";
import { useTandaTerima } from "../../../Context/TandaTerimaContext";

const SignForm = ({ idTandaTerima, resetState, type }) => {
  const tandaTerimaAPI = useTandaTerima();
  const { control, handleSubmit, setValue } = useForm();
  const [isOpen, setIsOpen] = useState(false);
  const [isKurir, setIsKurir] = useState(false);
  const [kurirName, setKurirName] = useState("");

  useEffect(() => {
    const group = localStorage.getItem("group");
    if (group === "kurir" && type === "yang_menyerahkan") {
      setIsKurir(true);
      
      const savedKurirString = localStorage.getItem("selectedKurir");
      if (savedKurirString) {
        try {
          const savedKurir = JSON.parse(savedKurirString);
          setKurirName(savedKurir.nama);
          setValue("dari", savedKurir.nama);
        } catch (error) {
          console.error("Error parsing saved kurir:", error);
        }
      }
    }
  }, [type, setValue]);

  const toggle = () => setIsOpen(!isOpen);

  const onSubmit = async (data) => {
    try {
      if (type === "penerima") {
        await tandaTerimaAPI.updatePenerimaSign(idTandaTerima, data);
      } else if (type === "yang_menyerahkan") {
        await tandaTerimaAPI.updateYangMenyerahkanSign(idTandaTerima, data);
        window.location.reload();
      }
      resetState();
      toggle();
    } catch (error) {
      console.error("Error saving signature:", error);
    }
  };

  return (
    <Fragment>
      <button
        className="btn btn-link"
        onClick={toggle}
        style={{ width: "200px" }}
        type="button"
      >
        Sign Here
      </button>

      <ModalContainer
        title={type === "penerima" ? "Penerima" : "Yang Menyerahkan"}
        isOpen={isOpen}
        toggle={toggle}
        size="lg"
        fullscreen="lg"
      >
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="dari"
            control={control}
            defaultValue={isKurir ? kurirName : ""}
            rules={{
              required: "Harap masukkan dari",
            }}
            render={({ field, fieldState }) => (
              <InputField
                label={"Nama"}
                fieldState={fieldState}
                {...field}
                isRequired
                disabled={isKurir && type === "yang_menyerahkan"}
              />
            )}
          />
          <SignCanvasField
            name="signature"
            control={control}
            label="Tanda Tangan"
            isRequired={true}
            className="mb-3"
          />
          <button type="submit" className="btn btn-primary">
            Simpan
          </button>
        </Form>
      </ModalContainer>
    </Fragment>
  );
};

export default SignForm;